import React , {useEffect} from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './pages/Layout/Layout';
import Login from './pages/Login/Login';
import Forgot from './pages/Login/Forgot';
import Signup from './pages/Login/Signup';

import { setUser } from "./store/authSlice";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";

function App() {
  const dispatch = useDispatch();
  var getlocalsession = localStorage.getItem('flaponestudentlogdetails');
  if(getlocalsession){
    var  getSavedLocalData = JSON.parse(atob(atob(localStorage.getItem('flaponestudentlogdetails'))));
  }
  else{
    var  getSavedLocalData ='';
  }
    if (getSavedLocalData) {
      dispatch(setUser(getSavedLocalData));
    }
  const isLoggedIn = useSelector((state) => state.auth.userid!==null);
  

  return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/:id" element={<Login />} />
        <Route path="/forgot-password" element={<Forgot />} />
        <Route path="/signup" element={<Signup />} />
        
        {isLoggedIn ? (
          <Route path="/*" element={<Layout />} />
        ) : (
          <Route
            path="/*"
            element={
              isLoggedIn ? (
                <Layout />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        )}
      </Routes>
  );
}

export default App;
